import { styled } from "@mui/material";
import MAccordion, { accordionClasses } from "@mui/material/Accordion";
import MAccordionActions from "@mui/material/AccordionActions";
import MAccordionDetails from "@mui/material/AccordionDetails";
import MAccordionSummary, { accordionSummaryClasses } from "@mui/material/AccordionSummary";
import { colors } from "@zapalacorp/tokens";

export const Container = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  marginTop: "24px",
  borderRadius: "8px !important",
  overflow: "hidden",
  border: `1px solid ${colors.gray200}`,
}));

export const Accordion = styled(MAccordion)(() => ({
  "&:before": {
    display: "none",
  },
  [`&.${accordionClasses.root}`]: {
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
    borderBottomLeftRadius: "8px",
    borderBottomRightRadius: "8px",
  },
  [`&.${accordionClasses.expanded}`]: {
    margin: "0 !important",
  },
  [`&:not(:first-of-type) .${accordionSummaryClasses.root}`]: {
    borderTop: `1px solid ${colors.gray200}`,
  },
}));

export const AccordionSummary = styled(MAccordionSummary)(() => ({
  padding: "16px !important",
  backgroundColor: colors.gray50,

  color: colors.gray600,
  fontWeight: 400,
  lineHeight: "24px",
  fontSize: "16px",
  letterSpacing: "0.5px",
  height: "56px",
  fontFamily: "Manrope",

  [`&.${accordionSummaryClasses.root}`]: {
    minHeight: "auto !important",
  },

  [`& .${accordionSummaryClasses.content}`]: {
    margin: "0 !important",
  },
}));

export const AccordionDetails = styled(MAccordionDetails)(() => ({
  padding: "16px !important",
  borderTop: `1px solid ${colors.gray200}`,
}));

export const AccordionActions = styled(MAccordionActions)(() => ({}));

export const MandatoryFieldTitle = styled("div")(() => ({
  fontFamily: "Manrope",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "20px",
  letterSpacing: "0.1px",
  color: colors.gray500,
}));

export const MandatoryFieldDisplay = styled("div")(() => ({
  fontFamily: "Manrope",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "20px",
  letterSpacing: "0.1px",
  color: colors.gray600,
}));

export const ConfigSection = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
}));

export const ConfigRow = styled("div")(() => ({
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  gap: "16px",
  flexWrap: "wrap",
}));

export const ConfigRowLeft = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  minWidth: "240px",
}));

export const ConfigRowTitle = styled("div")(() => ({
  fontFamily: "Manrope",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "20px",
  letterSpacing: "0.1px",
  color: colors.gray700,
}));

export const ConfigRowDescription = styled("div")(() => ({
  fontFamily: "Manrope",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "18px",
  letterSpacing: "0.1px",
  color: colors.gray500,
}));

export const ConfigRowRight = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: "12px",
}));

export const DividerLine = styled("div")(() => ({
  width: "100%",
  height: "1px",
  backgroundColor: colors.gray200,
}));

export const CustomerFieldsBox = styled("div")(() => ({
  marginTop: "8px",
  padding: "12px",
  borderRadius: "8px",
  border: `1px solid ${colors.gray200}`,
  backgroundColor: colors.gray50,
}));

export const CustomerFieldsTitle = styled("div")(() => ({
  fontFamily: "Manrope",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "18px",
  letterSpacing: "0.1px",
  color: colors.gray600,
  marginBottom: "8px",
}));

export const CustomerFieldsList = styled("ul")(() => ({
  margin: 0,
  paddingLeft: "18px",
  fontFamily: "Manrope",
  fontSize: "13px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.1px",
  color: colors.gray600,
}));

export const CustomerFieldsItem = styled("li")(() => ({
  marginBottom: "4px",
  fontWeight: 700,
}));
